import { IllumioEventEmitter } from "../common/event_emitter.js";
import IllumioDomUtils from "../common/dom_utils.js";

/**********************************************************************
 * Navigation MVC
 *********************************************************************/

export class SoftwareNavigationModel extends IllumioEventEmitter {
    constructor() {
        super();

        this.isDebug = false;
        
        $.ajax({
            dataType: 'json',
            method: 'get',
            contentType: 'application/json; charset=utf-8',
            url: '/api/v1/software/navigation.json',
            error: this.ajaxErrorHandler.bind(this),
            success: this.ajaxSuccessHandler.bind(this),
        });
    }
    
    // --- Handler ----------------------------------------------------
    /**
     * On successfully loading the navigation data, invoke the dataLoadEvent.notify() to
     * 1. update the download navigation (template's upper right)
     * 2. left navigation, if the target element is found
     * 3. download home page, if the target element is found
     */
    ajaxSuccessHandler(data, textStatus, jqXHR) {
        this.success = true;
        this.data = data.data;
        console.debug('SoftwareNavigationModel.ajaxSuccessHandler(): Successfully loaded navigation.json.');
        
        this.emit('renderNavigation', {});
        // console.debug(data);
        // console.debug(textStatus);
        // console.debug(jqXHR);
    }
    
    ajaxErrorHandler(jqXHR, textStatus, errorThrown) {
        this.success = false;
        // this.error = data.error;
        
        console.error('SoftwareNavigationModel.ajaxErrorHandler(): Error in loading navigation.json');
        console.debug(textStatus);
        console.debug(errorThrown);
        console.debug(jqXHR);
    }
}

export class SoftwareNavigationView extends IllumioEventEmitter {
    constructor(model) {
        super();
        
        this.model = model;
        this.model.on('renderNavigation', this.renderNavigationHandler.bind(this));
        this.model.on('loadContent', this.loadContentLoadHandler.bind(this));
        
        // var iloRightContent = document.getElementsByClassName('ilo-right-content')
        // this.contentDiv = (iloRightContent && iloRightContent.length>0) ? iloRightContent[0] : null;
    }

    renderNavigationHandler() {
        console.debug(this);
        this.softwareHomePageModelDataLoadEventHandler;
        this.renderSoftwareLeftNavigation();
    }

    /**
     * The handler for Download Navigation model, triggered when the data is loaded.
     * Populate both left navigation and off canvas left navigation.
     * Create content div, if not exist.
     */
    renderSoftwareLeftNavigation() {
        if (this.model.data) {
            const leftNavigationList = document.getElementById('supportLeftNavigation');
            if (supportLeftNavigation) {
                const productCategories = Object.keys(this.model.data);
                productCategories.forEach((categoryName, categoryIndex, categoriesArray) => {
                    const currentComponents = this.model.data[categoryName]['components'];
                    if (currentComponents) {
                        const componentNames = Object.keys(currentComponents);
                        if (componentNames.length>1) {
                            // Level 1 left navigation (without link)
                            if (this.isDebug===true) { console.debug(`[${categoryIndex}]: ${this.model.data[categoryName]['title']} without link`); }
                            const titleSpanElement = IllumioDomUtils.createSimpleTextBlock('span', this.model.data[categoryName]['title'], 'whitespace-nowrap');
                            const listElement = IllumioDomUtils.createListItem(titleSpanElement);
                            IllumioDomUtils.addItemToElement(leftNavigationList, listElement);

                            const childListElementRoot = document.createElement('ul');
                            componentNames.forEach((componentName, componentIndex, componentNamesArray) => {
                                if (currentComponents[componentName]['subnavigations']) {
                                    const subnavigationNames = Object.keys(currentComponents[componentName]['subnavigations']);
                                    if (subnavigationNames.length>1) {
                                        // Level 2 left navigtaion (without link)
                                        if (this.isDebug===true) { console.debug(`» [${componentIndex}] ${componentName}: ${currentComponents[componentName]['navigation_title']} without link [${subnavigationNames.length}]`); }
                                        const level2TitleSpanElement = IllumioDomUtils.createSimpleTextBlock('span', currentComponents[componentName]['navigation_title'], 'whitespace-nowrap');
                                        const grandChildListElementRoot = IllumioDomUtils.createListItem(level2TitleSpanElement);
                                        const subnavigations = currentComponents[componentName]['subnavigations'];
                                        const descendentUnorderedListElementRoot = document.createElement('ul');

                                        subnavigationNames.forEach((subnavigationName, subnavigationIndex, subnavigationArray) => {
                                            // Level 3 left navigation (with link)
                                            if (this.isDebug===true) { console.debug(`»» [${subnavigationIndex}] ${subnavigationName}: ${subnavigations[subnavigationName]['navigation_title']} with link`); }
                                            this.createNavAnchor(subnavigationName, componentName, descendentUnorderedListElementRoot, subnavigations[subnavigationName]['navigation_title']);
                                        });
                                        IllumioDomUtils.addItemToElement(grandChildListElementRoot, descendentUnorderedListElementRoot);
                                        IllumioDomUtils.addItemToElement(childListElementRoot, grandChildListElementRoot);
                                    } else {
                                        // Level 2 left navigation (with link)
                                        if (this.isDebug===true) { console.debug(`» [${componentIndex}] ${componentName}: ${currentComponents[componentName]['navigation_title']} with link [${subnavigationNames.length}]`); }
                                        this.createNavAnchor('download', componentName, childListElementRoot, currentComponents[componentName]['navigation_title']);
                                    }
                                }
                            });
                            if (childListElementRoot.hasChildNodes()) {
                                IllumioDomUtils.addItemToElement(listElement, childListElementRoot);
                            }
                        } else {
                            // Level 1 left navigation (with link)
                            if (this.isDebug===true) { console.debug(`[${categoryIndex}]: ${this.model.data[categoryName]['title']} with link`); }
                            this.createNavAnchor('download', categoryName, leftNavigationList, this.model.data[categoryName]['title']);
                        }
                    }
                });
            }
        } else {
            console.error('SoftwareNavigationView.renderSoftwareLeftNavigation(): this.model appears to be null.');
        }
    }
    
    /**
     * The handler for Download Navigation model, triggered when the data is loaded.
     * Populate the link in the Software Home Page, to be identifed by the element id of softwarePageListing.
     */
    softwareHomePageModelDataLoadEventHandler() {
console.debug(this);
        /*
        if (this.model.data) {
            var divElement = document.getElementById('softwareHomeTile');
            if (divElement) {
                console.debug('DownloadNevigationView: DIV element of softwareHomeTile found!');
                var model = new SoftwareHomeTileModel();
                var view = new SoftwareHomeTileView(model);
                model.setData(this.model.data);
                var controller = new SoftwareHomeTileController(view, model);
            } else {
                console.debug('SoftwareNavigationView: Element id of softwarePageListing not found! No further action.');
            }
        } else {
            console.error('SoftwareNavigationView: this.model appears to be null.');
        }
        */
    }
    
    loadContentLoadHandler() {
        console.debug(`SoftwareNavigationView.loadContentLoadHandler(): location.hash: ${location.hash}`);
        if (location.hash) {
            // Location hash is defined. Let's retrieve the navigation element and highlight it.
            const hashParts = location.hash.substring(1).split('/');
            if (hashParts.length>=2) {
                const elementId = `${hashParts[0]}-${hashParts[1]}`;
                const elements = document.getElementsByClassName(elementId);
                if (elements.length>0) {
                    this.highlightLink(elements[0]);
                }
            } else {
                console.error('SoftwareNavigationView: navigationModelDataLoadEvent(): Unable to determine the elementId due to incorrect location.hash.');
            }
        } else {
            this.clickDefaultNavigationLink();
        }
    }

    createNavAnchor(key, itemName, targetElement, text) {
        if (this.isDebug===true) {
            console.debug(`SoftwareNavigationView.createNavAnchor(): » key: ${key}`);
            console.debug(`SoftwareNavigationView.createNavAnchor(): » itemName: ${itemName}`);
            console.debug(`SoftwareNavigationView.createNavAnchor(): » targetElement: ${targetElement}`);
            console.debug(`SoftwareNavigationView.createNavAnchor(): » text: ${text}`);
        }

        const elementId = `${itemName}-${key}`;
        const locationHash = `#${itemName}/${key}`;
        const anchorElement = IllumioDomUtils.createAnchorTag(locationHash, text, null);
        anchorElement.id = elementId;
        anchorElement.classList.add(elementId);
        anchorElement.classList.add('whitespace-nowrap');
        anchorElement.dataset['hash'] = locationHash;
        
        const listElement = IllumioDomUtils.createListItem(anchorElement);
        var activeClassName = location.hash.replace('/','-').replace('#','').split('/')[0];
        if (activeClassName == elementId) {
            listElement.classList.add('menu-active');
        }
        IllumioDomUtils.addItemToElement(targetElement, listElement);
 
        return elementId;
    }

    /**
     * Handler for clicking the navigation link.
     */
    navigationLinkOnClickHandler(event) {
        this.highlightLink(event.target);
    }
    
    setContentView(contentView) {
        this.contentView = contentView;
    }
        
        /**
         * A utility function to change navigation link highlight.
         */
        highlightLink(anchorElement) {
            console.debug(`highlightLink(): » anchorElement:`);
            console.debug(anchorElement);

            if (anchorElement) {
                let menuRootElement = anchorElement;
                while (menuRootElement) {
                    console.debug(menuRootElement);
                    console.debug(`» menuRootElement.tagName: ${menuRootElement.tagName} [${menuRootElement.tagName==='UL'}]`);
                    console.debug(`» menuRootElement.classList.contains('menu'): ${menuRootElement.classList.contains('menu')}`);
                    if (menuRootElement==null) {
                        break;
                    } else if (menuRootElement.tagName==='UL' && menuRootElement.classList.contains('menu')) {
                        console.info(`»»» Found it!`);
                        break;
                    } else {
                        menuRootElement = menuRootElement.parentElement;
                    }
                }

                if (menuRootElement) {
                    // Remove active from existing anchor tags
                    const menuActiveElements = document.querySelectorAll('.menu-active');
                    for (const element of menuActiveElements) {
                        element.classList.remove('menu-active');
                    }

                    // Add active class to the target
                    anchorElement.parentElement.classList.add('menu-active');
                }
            }
        }
        
        /**
         * A utility function to programmatically click the first left navigation link (default). 
         * Typically invoked when location hash is empty.
         */
        clickDefaultNavigationLink() {
            let intervalId = null;
            let intervalCounter = 0;
            let intervalMaxCounter = 60; // Expire the counter after 60 attempts or 15 seconds (60*250ms)
            const intervalHandler = function() {
                // if (this.model.defaultNavigationElementId) {
                //      const elements = document.getElementsByClassName(this.model.defaultNavigationElementId);
                //      if (elements.length>0) {
                //          console.debug(elements[0]);
                //          elements[0].click();
                //      } else {
                //          console.warn(`SoftwareNavigationView.clickDefaultNavigationLink(): elements of class ${this.model.defaultNavigationElementId} not found!`);
                //      }
                //      clearInterval(intervalId);
                //      console.debug(`ContentController: Clear interval ${intervalId} since this.model.defaultNavigationElementId ${this.model.defaultNavigationElementId} is found.`);
                const firstNavigationAnchor = document.querySelector('#supportLeftNavigation a');
                if (firstNavigationAnchor) {
                    console.debug(`clickDefaultNavigationLink(): » firstNavigationAnchor: `);
                    console.debug(firstNavigationAnchor);
                    firstNavigationAnchor.click();
                    clearInterval(intervalId);
                } else if (intervalCounter>intervalMaxCounter) {
                    clearInterval(intervalId);
                    console.warn(`ContentController: Clear interval ${intervalId} after ${intervalMaxCounter} intervals.`);
                }
                intervalCounter++;
            }
            intervalId = setInterval(intervalHandler.bind(this), 250);
            console.debug(`SoftwareNavigationView.clickDefaultNavigationLink(): intervalId: ${intervalId}`);
        }
}

export class SoftwareNavigationController extends IllumioEventEmitter {
    constructor(model, view) {
        super();

        this.model = model;
        this.view = view;
    }
    
    /**
     * Implement logic to retrieve left navigation links and set highlight.
     * It depends on the location.hash.
     * Example values are #pce/download, #ven/upgrade.
     * The location.hash may contain version info. 
     * The function disregards it becuase it is not needed for navigation highlight.
     */
    updateAnchorElement() {
        let matchingHash = null;
        const hashParts = location.hash.split('/');
        if (hashParts.length>=2) {
            matchingHash = hashParts.splice(0, 2).join('/');
        }
        console.debug(`SoftwareNavigationController.updateAnchorElement(): » matchingHash: ${matchingHash}`);

        if (matchingHash) {
            const downloadLinks = document.querySelectorAll('main div#contentNavigationDrawerSide .menu li a');
            for (const anchorElement of downloadLinks) {
                if (anchorElement.href.indexOf(matchingHash)>0) {
                    this.view.highlightLink(anchorElement);
                }
            }
        }
    }
}
    
